import { render, staticRenderFns } from "./RehabCoursesHome.vue?vue&type=template&id=62943a61&scoped=true"
import script from "./RehabCoursesHome.vue?vue&type=script&lang=js"
export * from "./RehabCoursesHome.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesHome.vue?vue&type=style&index=0&id=62943a61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62943a61",
  null
  
)

export default component.exports